<template>
  <div>
    <span
      class="sidebar-icon"
      @click="openSideBar = !openSideBar"
      :class="{'open-sidebar': openSideBar}"
    >
      <i class="fas fa-bars" v-if="!openSideBar"></i>
      <i class="fas fa-times" v-else></i>
    </span>

    <div class="admin-overlay" v-if="openSideBar" @click="openSideBar = false"></div>

    <div class="admin-sidebar" :class="{'open-sidebar': openSideBar}">
      <div class="media align-items-center">
        <img
          src="https://images.unsplash.com/photo-1573461811636-666c0df96104?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60"
          width="60"
          height="60"
          class="mr-2 rounded-circle border user-image"
          alt="user-image"
        />
        <div class="media-body">
          <h5 class="m-0">{{ userName }}</h5>
          <span class="text-muted">{{ userEmail }}</span>
        </div>
      </div>
      <hr />

      <div class="nav flex-column">
        <router-link to="/admin" class="nav-link" exact active-class="active">
          <i class="mr-1 fas fa-home"></i> Home
        </router-link>
        <router-link to="/admin/products" class="nav-link" active-class="active">
          <i class="mr-1 fas fa-box"></i> products
        </router-link>
        <router-link to="/admin/profile" class="nav-link" active-class="active">
          <i class="mr-1 fas fa-user"></i> Profile
        </router-link>
        <!-- <router-link to="/hhh" class="nav-link" active-class="active">
          <i class="mr-1 fas fa-cog"></i> Settings
        </router-link> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdminSidebar",
  methods: {},
  data() {
    return {
      openSideBar: false
    };
  },
  computed: {
    userName() {
      return this.$store.getters["authModule/getUserData"].name ? this.$store.getters["authModule/getUserData"].name : "User Name";
    },
    userEmail() {
      return this.$store.getters["authModule/getUser"] ? this.$store.getters["authModule/getUser"].email : "";
    }
  }
};
</script>


<style lang="scss" scoped>
@import "../../sass/helpers/_variables.scss";
.admin-page {
  position: relative;
}
.sidebar-icon {
  position: fixed;
  z-index: 9999;
  left: 0;
  top: 112px;
  padding: 5px 10px;
  cursor: pointer;
  font-size: 20px;
  background: $darkColor;
  color: #fff;
  transition: all 0.5s;
  text-align: center;
  &.open-sidebar {
    left: 240px;
  }
}
.admin-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #0000002e;
  z-index: 9;
  cursor: pointer;
  min-height: 100vh;
}
.admin-sidebar {
  background: #fff;
  position: fixed;
  left: 0;
  width: 240px;
  height: 100vh;
  z-index: 999;
  padding: 20px 10px;
  overflow-y: auto;
  border-right: 2px solid lightgrey;
  transition: all 0.5s;
  transform: translateX(-100%);
  &.open-sidebar {
    transform: translate(0);
  }
  .nav .nav-link {
    color: inherit;
    margin-bottom: 10px;
    transition: all 0.3s;
    &:hover,
    &.active {
      background: $darkColor;
      color: #fff;
    }
  }
  .user-image {
    object-fit: cover;
  }
}
</style>